"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function AgentsLoggedInIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "34", height: "34", viewBox: "0 0 34 34", id: "agent-logged-in-icon" },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#777A82", d: "M11 32h4v-4h-4z" }),
            React.createElement("path", { fill: "#767F8C", d: "M4 16v8.978l2.83 3.012L11 28V16zM23 16v12l4.001-.01L30 24.978V16z" }),
            React.createElement("path", { fill: "#8F96A0", d: "M4 16v8.978L7 28V16zM27 16v12l3-3v-9z" }),
            React.createElement("path", { fill: "#B2B9C2", d: "M30 16h-3v-1.396C27 9.321 22.678 5 17.396 5h-.801C11.296 5 7 9.295 7 14.594V16H4v-1.396C4 7.672 9.672 2 16.604 2h.805C24.363 2 30 7.637 30 14.59V16z" }))));
}
exports.AgentsLoggedInIcon = AgentsLoggedInIcon;
